import { render, staticRenderFns } from "./AnalogClock.vue?vue&type=template&id=6bce7c32&scoped=true&lang=pug&"
import script from "./AnalogClock.vue?vue&type=script&lang=js&"
export * from "./AnalogClock.vue?vue&type=script&lang=js&"
import style0 from "./AnalogClock.vue?vue&type=style&index=0&id=6bce7c32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bce7c32",
  null
  
)

export default component.exports